import { ArrowRightAlt, Close } from "@material-ui/icons";
import { IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { Typeahead } from 'react-bootstrap-typeahead';
import { Controller, useForm } from "react-hook-form";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import Select from 'react-select';
import useOrder from "../../../context/OrderContext";
import { useGetConsignorQuery } from "../../../features/pickupInfo/pickupInfoSlice";
import CountryProvince from "../../CountryProvince";
import LocationAutoComplete from "./LocationAutocomplete";
import timeConverter from "./timeConverter";
import LocationNotes from "./LocationNotes";


const Dropupinfo = () => {
  const { control } = useForm();
  const { dropInfo, setDropInfo, fetchDropupInfo, Dropuphandler, populateAccount, dropDisable, dropupData, dropErrors,
    setSelectState, handlecountry, handleCity, setAutoDropup, dropAccessorial, setDropAccessorial, accessorial, dropSelection, setDropSelection, fullAddressDropOff } = useOrder();
  const { city, handleProvince, newHandleCountry, handleUniqueCity } = CountryProvince();
  const { data: pickupInfo } = useGetConsignorQuery()
  const listofaccount = pickupInfo?.data?.map((item, index) => ({ ...item, id: index + new Date().getTime().toString() }))
  const [autocomplete, setAutocomplete] = useState({});
  const [province, setProvince] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const cityList = city?.data.map((a) => { return { name: a.city, id: a.id } });
  const [searchString, setSearchString] = useState('');

  const getAccountInfo1 = async (dropInfo) => {
    fetchDropupInfo(dropInfo)
  }
  const handleOnSelect1 = async (item) => {
    setSearchString(item?.address)
    const dropInfo = item?.consignorId;
    const selectedAccount = await getAccountInfo1(dropInfo)
    setDropInfo(selectedAccount)
    setAutoDropup(true)
    setSearchString("")
  };

  const handleSelect = (e) => {
    const mapData = e?.map((item) => item?.value
    )
    if (mapData && mapData.length > 0) {
      setDropAccessorial(mapData)
    }
    else {
      setDropAccessorial([])
    }
  }
  const arr = accessorial?.data?.data?.map((item) => ({ value: item?.accessorialID, label: item?.accessorialDescription })) || [];


  const getCityID = async (cityName, provinceName) => {
    const result = await handleUniqueCity({ cityName, provinceName });
    return result?.data?.data;
  }


  // 1) When the user Select a city:
  useEffect(() => {
    (async () => {
      if (dropSelection?.length === 0) {

        // clear everything
        setDropInfo(d => ({
          ...d,
          city: null, cityName: null,
          provineStateID: null, provineSateName: null,
          countryId: null, countryname: null
        }));
        setProvince([]);
        setCountryList([]);
        return;
      }

      const cityId = dropSelection[0].id;
      const cityName = dropSelection[0].name;
      setDropInfo(d => ({ ...d, city: cityId, cityName }));

      // fetch full province list
      const provRes = await handleProvince(cityId);
      const allProvs = provRes.data.data;
      setProvince(allProvs);

      // if we already have one in dropInfo, mark it selected
      const wantedProvID = dropInfo?.provineStateID || (allProvs.length === 1 && allProvs[0]?.provineStateID);;
      if (wantedProvID) {
        const defaultProv = allProvs.find(p => p.provineStateID === wantedProvID);
        if (defaultProv) {
          setDropInfo(d => ({
            ...d,
            provineStateID: defaultProv.provineStateID,
            provineSateName: defaultProv.provineSateName
          }));
        }
      }

      // now fetch countries for whichever province is in dropInfo (or the first if only one)
      const chosenProvID = dropInfo?.provineStateID || (allProvs.length === 1 && allProvs[0]?.provineStateID);
      if (chosenProvID) {
        const countryRes = await newHandleCountry(chosenProvID);
        const allCountries = countryRes.data.data;
        setCountryList(allCountries);

        // auto-select a country if one was already stored
        const wantedCountryID = dropInfo?.countryId;
        if (wantedCountryID) {
          const defaultCountry = allCountries?.find(c => c.countryId === wantedCountryID);
          if (defaultCountry) {
            setDropInfo(d => ({
              ...d,
              countryId: defaultCountry.countryId,
              countryname: defaultCountry.countryname
            }));
          }
        }
      }
    })();
  }, [dropSelection])


  const setCountry = async (e) => {
    if (e.target.value !== 'Select') {
      const cList = await newHandleCountry(e.target.value);
      setCountryList(cList.data.data)
      setDropInfo(dropInfo => ({ ...dropInfo, countryId: cList.data.data[0].countryId, countryname: cList.data.data[0].countryname }))
    }
    else {
      setCountryList([]);
    }
  }

  useEffect(async () => {
    if (Object.keys(autocomplete).length !== 0) {
      const id = await getCityID(autocomplete.city, autocomplete.province)
      setDropSelection([{ name: autocomplete.city, id: id }]);
      const lst = await handleProvince(id)
      const prov = lst.data.data.find((ele) => ele.provineSateName === autocomplete.province)
      setProvince([prov]);
      const country = autocomplete.country === "CAN" ? { countryId: 1, countryname: 'CAN' } : { countryId: 2, countryname: 'USA' }
      const countryID = autocomplete.country === "CAN" ? 1 : 2;
      setDropInfo({
        ...dropInfo, streetName: autocomplete.streetName, street: autocomplete.streetNum, unit: autocomplete.unit,
        provineStateID: prov.provineStateID, provineSateName: autocomplete.province, city: id, cityName: autocomplete.city,
        countryId: countryID, countryname: autocomplete.country, postalCode: autocomplete.postalCode
      });
      setCountryList([country]);
    }
    else {
      setDropInfo({ ...dropInfo, streetName: "", street: "", unit: "" });
    }
  }, [autocomplete])

  const handleOnClear1 = () => {
    setDropInfo("")
    setDropSelection([]);
    setCountryList([]);
    setDropInfo(prevState => ({ ...prevState, appointment: "" }));
    setDropAccessorial([]);
    setSearchString("")
  }

  const formatResult1 = (item) => {
    return (
      <div className="result-wrapper">
        <span className="result-span">{item.address} </span>
      </div>
    );
  };

  useEffect(() => {
    if (dropupData?.provineStateID) {
      let target = dropupData?.provineStateID
      handleCity({ target: { value: target } })
    }
    if (dropupData?.cityId && dropupData?.cityName) {
      setDropSelection([{ name: dropupData?.cityName, id: dropupData?.cityId }]);
    }
    if (dropupData?.countryId) {
      let target;
      if (dropupData?.countryId === 1) {
        target = { countryId: 1, countryname: 'CAN' };
      } else {
        target = { countryId: 2, countryname: 'USA' };
      }
      setCountryList([target]);
    }
  }, [dropupData])

  const setValues = () => {
    setDropSelection([{ name: dropInfoRef.current.cityName, id: dropInfoRef.current.city }]);
  }

  const dropInfoRef = useRef();
  dropInfoRef.current = dropInfo;

  return (
    <>
      <Row className="mb-3">
        <Col sm={6}>
          <div style={{ position: "relative" }}>
            {fullAddressDropOff() !== "" ? <IconButton disableRipple sx={{ color: "black", position: "absolute", fontSize: "3px", right: -1, bottom: 3, zIndex: 10 }} onClick={handleOnClear1}><Close fontSize="4px" /></IconButton> : null}
            <ReactSearchAutocomplete
              onSearch={(string) => setSearchString(string)}
              inputSearchString={searchString}
              className="form-control11"
              placeholder={fullAddressDropOff() !== "" ? fullAddressDropOff() : "Select"}
              items={listofaccount}
              fuseOptions={{ keys: ["address"] }} // Search on both fields
              resultStringKeyName="address" // String to display in the results
              onSelect={handleOnSelect1}
              onFocus={formatResult1}
              onClear={handleOnClear1}
              formatResult={formatResult1}
              showItemsOnFocus={formatResult1}
              inputDebounce={100}
              showIcon={false}
              styling={{
                height: "48px",
                border: "1px solid #cbcbcb",
                borderRadius: "4px",
                backgroundColor: "white",
                boxShadow: "none",
                hoverBackgroundColor: "#cbcbcb",
                iconColor: "#000",
                lineColor: "#cbcbcb",
                placeholderColor: "#000",
                clearIconMargin: "3px 8px 0 0",
                zIndex: 2,
              }}
            />
          </div>
        </Col>
        <Col sm={6}>
          <div className="search-form">
            <LocationAutoComplete autocomplete={autocomplete} setAutocomplete={setAutocomplete} />
          </div>
        </Col>
      </Row>
      <fieldset className="mt-4 mb-3">
        <label className="label-heading">Address Info</label>
        <Row className="fieldset-row mb-3">
          <Col sm={3}>
            <Form.Group controlId="st">
              <FloatingLabel controlId="floatingInput" label="Consignee/Receiver" >
                <Form.Control type="text" placeholder="Consignee/Receiver" name="customer" value={dropInfo?.customer || ""} onChange={e => { Dropuphandler(e); }} className={`input ${dropErrors.customer && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.customer && (<p className="help is-danger">{dropErrors.customer}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="st">
              <FloatingLabel controlId="floatingInput" label="Street No." >
                <Form.Control type="text" placeholder="Street No." name="street" value={dropInfo?.street ? dropInfo?.street : ""} onChange={e => { Dropuphandler(e); }} className={`input ${dropErrors.street && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.street && (<p className="help is-danger">{dropErrors.street}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="Street">
              <FloatingLabel controlId="floatingInput" label="Street Name" >
                <Form.Control type="text" placeholder="Street Name" name="streetName" value={dropInfo?.streetName ? dropInfo?.streetName : ""} onChange={e => { Dropuphandler(e); }} className={`input ${dropErrors.streetName && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.streetName && (<p className="help is-danger">{dropErrors.streetName}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="Unit">
              <FloatingLabel controlId="floatingInput" label="Unit" >
                <Form.Control type="text" autoComplete="off" placeholder="Unit" name="unit" onChange={(e) => { Dropuphandler(e); }} value={(dropInfo?.unit && dropInfo?.unit !== "null") ? dropInfo?.unit : ""} className={`input ${dropErrors.unit && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={3}>
            <Form.Group controlId="city">
              <Typeahead
                id='cityAutocomplete'
                labelKey="name"
                onChange={setDropSelection}
                options={cityList}
                placeholder="Choose a city..."
                selected={dropSelection}
              />
            </Form.Group>
            {dropErrors.city && (<p className="help is-danger">{dropErrors.city}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="pr">
              <FloatingLabel controlId="floatingInput" label="Province" >
                <Form.Select aria-label="Floating label select example" name="provineStateID" onChange={(e) => { setSelectState(e.target.value); Dropuphandler(e); handleCity(e); setCountry(e); }}
                  value={dropInfo?.provineStateID} className={`input ${dropErrors.provineStateID && 'is-danger'}`}>
                  <option>Select</option>:
                  {
                    province?.map((data, index) => (
                      <option key={index} value={data.provineStateID}>{data.provineSateName}</option>
                    ))

                  }
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
            {dropErrors.provineStateID && (<p className="help is-danger">{dropErrors.provineStateID}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="Country">
              <FloatingLabel controlId="floatingSelectGrid" label="Country">
                <Form.Select aria-label="Floating label select example" name="countryId" onChange={e => { handlecountry(e); Dropuphandler(e) }} value={dropInfo?.countryId ? dropInfo?.countryname : "Select"} className={`input ${dropErrors.countryId && 'is-danger'}`}>
                  {countryList.length === 0 &&
                    <option>Select</option>
                  }
                  <>
                    {
                      countryList?.map((data, index) => (
                        <option key={index} value={data?.countryId}>{data?.countryname}</option>
                      ))

                    }
                  </>
                </Form.Select>
              </FloatingLabel>
            </Form.Group>
            {dropErrors.countryId && (<p className="help is-danger">{dropErrors.countryId}</p>)}
          </Col>
          <Col sm={3}>
            <Form.Group controlId="postal/zip">
              <FloatingLabel controlId="floatingInput" label="Postal Code" >
                <Form.Control type="text" autoComplete="off" placeholder="Postal code" name="postalCode" onChange={(e) => { Dropuphandler(e); }} value={dropInfo?.postalCode || ""} className={`input ${dropErrors.postalCode && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.postalCode && (<p className="help is-danger">{dropErrors.postalCode}</p>)}
          </Col>
        </Row>
      </fieldset>

      <fieldset className="mt-4">
        <label className="label-heading">Personal Info</label>
        <Row className="mb-1 fieldset-row">
          <Col sm={4}>
            <Form.Group controlId="Contact">
              <FloatingLabel controlId="floatingInput" label="Contact Name" >
                <Form.Control type="text" autoComplete="off" placeholder="Contact" name="contact" value={dropInfo?.contact || ""} onChange={e => { Dropuphandler(e); }} className={`input ${dropErrors.contact && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.contact && (<p className="help is-danger">{dropErrors.contact}</p>)}
          </Col>
          <Col sm={4}>
            <Form.Group controlId="phone">
              <FloatingLabel controlId="floatingInput" label="Phone" >
                <Form.Control type="text" autoComplete="off" placeholder="Phone" name="phone" value={dropInfo?.phone || ""} onChange={e => { Dropuphandler(e); }} className={`input ${dropErrors.phone && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.phone && (<p className="help is-danger">{dropErrors.phone}</p>)}
          </Col>
          <Col sm={4}>
            <Form.Group controlId="email">
              <FloatingLabel controlId="floatingInput" label="Email" >
                <Form.Control type="text" autoComplete="off" placeholder="Email" name="emailAddress" onChange={(e) => { Dropuphandler(e); }} value={dropInfo?.emailAddress ? dropInfo?.emailAddress : ""} className={`input ${dropErrors.emailAddress && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.emailAddress && (<p className="help is-danger">{dropErrors.emailAddress}</p>)}
          </Col>
        </Row>
      </fieldset>
      <fieldset className="mt-4">
        <label className="label-heading">Extra Info</label>
        <Row className="fieldset-row mb-4">
          <Col sm={4}>
            <Form.Group controlId="Dropupref">
              <FloatingLabel controlId="floatingInput" label="Dropup(Ref/info)" >
                <Form.Control type="text" placeholder="Dropup(Ref/info)" name="dropoffRefence" value={dropInfo?.dropoffRefence ? dropInfo?.dropoffRefence : ""} onChange={e => { Dropuphandler(e) }} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col sm={8}>
            <Controller
              control={control}
              name="accessorialID"
              render={({ field: { onChange, value, name, ref } }) => (
                <Select
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      height: "47px",
                    }),
                  }}
                  isMulti
                  placeholder="Accessorial"
                  name={name}
                  ref={ref}
                  options={arr}
                  value={arr.filter(option => dropAccessorial.includes(option.value))}
                  onChange={(e) => handleSelect(e)}
                />
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form.Group controlId="Appointment">
              <FloatingLabel controlId="floatingInput" label="Appointment" >
                <Form.Control type="datetime-local" placeholder="Appointment" name="appointment" value={dropInfo?.appointment} onChange={e => { Dropuphandler(e) }} />
              </FloatingLabel>
            </Form.Group>
            {dropErrors.appointment && (<p className="help is-danger">{dropErrors.appointment}</p>)}
          </Col>
          <Col sm={4}>
            <Form.Group controlId="Opening Time">
              <FloatingLabel controlId="floatingInput" label="Opening Time" >
                <Form.Control type="time" placeholder="Opening Time" onChange={e => Dropuphandler(e)} name="openingTime" value={timeConverter(dropInfo?.openingTime ?? dropInfo?.open) || ""} className={`input ${dropErrors.openingTime && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col sm={4}>
            <Form.Group controlId="Closing Time">
              <FloatingLabel controlId="floatingInput" label="Closing Time" >
                <Form.Control type="time" placeholder="Closing Time" onChange={e => Dropuphandler(e)} name="closeTime" value={timeConverter(dropInfo?.closeTime) || ""} className={`input ${dropErrors.closeTime && 'is-danger'}`} />
              </FloatingLabel>
            </Form.Group>
          </Col>
        </Row>
      </fieldset>
      <Row className="mt-3">
        <Col sm={6}>
          <div className="populate-btn d-flex">
            <Button className="populate-account" onClick={async (e) => { await populateAccount(e); setValues() }} disabled={dropDisable} value="populatedrop">Populate account <ArrowRightAlt /></Button>
            <Button className="notes"><LocationNotes values={dropInfo} onChange={Dropuphandler} /></Button>
          </div>
        </Col>
      </Row>
    </>
  );
}
export default Dropupinfo;